var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElasticPathMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#2BCC7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.252 26.7458C31.5821 30.0874 31.6202 33.8682 30.2901 37.2097L40.6972 37.1784V26.7492L30.252 26.7458Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2527 26.7459L37.6364 19.3746L30.2448 12L23.6719 18.5579L27.1105 21.9887C28.5146 23.3895 29.5627 25.015 30.2527 26.7459Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1105 41.9391L23.6719 45.3698L30.2448 51.9277L37.6364 44.553L30.2908 37.2098C29.6008 38.9407 28.5146 40.5382 27.1105 41.9391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticPathMark);
export default __webpack_public_path__ + "static/media/elastic-path-mark.d8657be07d0a5d90b3bb2b0a7927525e.svg";
export { ForwardRef as ReactComponent };